import * as constants from './pointShopItem.constants';

export const createPointShopItem = (data) => ({ type: constants.CREATE_POINT_SHOP_ITEM, data });
export const updatePointShopItemStatus = (data) => ({ type: constants.UPDATE_POINT_SHOP_ITEM_STATUS, data });
